const situations = [
  {
    icon: 'ri-task-line',
    title: 'Невыполнение задачи',
    desc: 'Как обсуждать нарушение договорённостей и возвращать ответственность сотруднику за результат, а не принимать обещание «исправиться» без анализа причин.',
  },
  {
    icon: 'ri-error-warning-line',
    title: 'Ошибки',
    desc: 'Как разбирать ошибку без перехода на обвинения, фокусируясь на причинах и корректирующих действиях, и одновременно не снижать требования к результату.',
  },
  {
    icon: 'ri-drop-line',
    title: 'Низкое качество работы',
    desc: 'Как говорить о результате, который не соответствует стандарту, используя конкретные критерии и примеры вместо общих оценок.',
  },
  {
    icon: 'ri-timer-line',
    title: 'Нарушение сроков',
    desc: 'Как выяснять реальные причины срыва сроков, а не ограничиваться формальным обещанием «больше не повторится».',
  },
  {
    icon: 'ri-arrow-down-line',
    title: 'Снижение эффективности',
    desc: 'Как обсуждать изменение результатов сотрудника, выявлять причины спада и совместно искать пути восстановления продуктивности.',
  },
  {
    icon: 'ri-shake-hands-line',
    title: 'Конфликт',
    desc: 'Как провести разговор между участниками конфликта, вернуть обсуждение к рабочей задаче и договориться о правилах взаимодействия.',
  },
  {
    icon: 'ri-close-circle-line',
    title: 'Сопротивление',
    desc: 'Как работать с сотрудником, который не принимает решение или изменение, выяснять причины сопротивления и искать конструктивный выход.',
  },
  {
    icon: 'ri-file-list-3-line',
    title: 'Нарушение правил',
    desc: 'Как обсуждать систематическое нарушение договорённостей, отделяя единичный случай от повторяющегося поведения.',
  },
  {
    icon: 'ri-megaphone-line',
    title: 'Непопулярные решения',
    desc: 'Как сообщать решения, которые сотруднику не нравятся, объясняя причины и сохраняя рабочие отношения.',
  },
  {
    icon: 'ri-user-unfollow-line',
    title: 'Увольнение',
    desc: 'Как руководителю вести сложный разговор об увольнении профессионально и корректно, сохраняя достоинство сотрудника.',
  },
  {
    icon: 'ri-star-line',
    title: 'Сильный, но сложный сотрудник',
    desc: 'Как давать обратную связь специалисту, от которого зависит бизнес, не рискуя его демотивировать или потерять.',
  },
  {
    icon: 'ri-seedling-line',
    title: 'Развитие сотрудника',
    desc: 'Как использовать обратную связь не только для исправления ошибок, но и для развития сильных сторон и карьерного роста сотрудника.',
  },
];

export default function DifficultSituations() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Сложные разговоры руководителя с сотрудниками
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Какие управленческие ситуации мы отрабатываем на тренинге — от повседневной обратной связи до самых непростых разговоров
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {situations.map((s) => (
            <div key={s.title} className="bg-gray-50 rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-300 transition-colors group">
              <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center mb-4 group-hover:bg-teal-200 transition-colors">
                <i className={`${s.icon} text-teal-700 text-lg`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-sm mb-2">{s.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}